export default "__VITE_ASSET__52ee8a7c__"